import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 27"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="fcuewwymib">
        <stop stopColor="#4AB6F5" offset="0%" />
        <stop stopColor="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="nsy12b3s3a">
        <stop stopColor="#7DCFFF" offset="0%" />
        <stop stopColor="#60A2FE" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.078%"
        y1="14.721%"
        x2="91.089%"
        y2="87.999%"
        id="9qufxwtj2c"
      >
        <stop stopColor="#E2F2FF" offset="0%" />
        <stop stopColor="#E2F2FF" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.5.821c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.023 7.297c0 2.468-1.54 5.495-3.44 8.161-2.494 3.499-5.655 6.52-6.88 6.52-1.225 0-4.386-3.021-6.88-6.52-1.9-2.666-3.44-5.693-3.44-8.161 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.5.82Z"
        stroke="url(#nsy12b3s3a)"
        fill="url(#fcuewwymib)"
      />
      <path
        d="M9.686 1.248 8.58.15a.51.51 0 0 0-.722 0c-.2.2-.2.524 0 .724l.715.718-.529.551a.46.46 0 0 0 0 .64c.084.09.197.134.31.134h.004l.6-.001v4.682c0 .174-.142.32-.314.32h-.006a.312.312 0 0 1-.307-.313V4.687c0-.748-.606-1.353-1.353-1.353a.313.313 0 0 1-.313-.313V.834A.833.833 0 0 0 5.833 0H1.458a.833.833 0 0 0-.833.833v8.03a.097.097 0 0 1-.095.096.532.532 0 0 0-.53.497.52.52 0 0 0 .521.543h6.243a.52.52 0 1 0 .008-1.04.105.105 0 0 1-.106-.106V4.689a.312.312 0 0 1 .534-.22.312.312 0 0 1 .092.221v2.916a1.354 1.354 0 1 0 2.708 0v-5.61c0-.294-.121-.559-.314-.748Zm-8.02.235c0-.317.3-.574.667-.574h2.834c.367 0 .666.257.666.574v1.58c0 .316-.299.573-.666.573H2.333c-.367 0-.666-.257-.666-.574V1.483Zm7.5 1.243-.576.001h-.257l.352-.444.369-.465a.802.802 0 0 1 .113.417v.49Z"
        transform="translate(7 6)"
        fill="url(#9qufxwtj2c)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
